export enum OnboardingStatus {
  Registered = `REGISTERED`,
  Configured = `CONFIGURED`,
  Finished = `FINISHED`,
  Error = `ERROR`,
}

export const ONBOARDING_ENTITY = `ONBOARDING`
